import * as React from 'react'

import { Button } from '../actions/button'
import { IconChevronLeft } from '../lib/icons'

export interface AppShellBackProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'aria-label'
> {
  /** aria-label of the arrow: it is an icon-only button. */
  label: string
}

/** The way back, in the header where the brand stood: pass it as `AppShell`'s `back`. */
export const AppShellBack = React.forwardRef<HTMLButtonElement, AppShellBackProps>(
  ({ label, ...props }, ref) => (
    <Button ref={ref} variant="glass" size="icon" aria-label={label} {...props}>
      <IconChevronLeft aria-hidden="true" />
    </Button>
  ),
)
AppShellBack.displayName = 'AppShellBack'
